module.exports = __webpack_public_path__ + "static/media/profile-preview-large.ba49f5af.svg";